export default {
  meta: {
    title: '推荐报告查询',
    url: '/recommend/modal', // 埋点用，记录所属模块
    // eventId: 'a1150473-e462-4783-8eff-b54b5b60a592'
  },
};
